import {
  SEARCH_LIST,
  SEARCH_LIST_SUCCESS,
  SEARCH_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  searchText: "",
}

const Search = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
        searchText: action.payload.data.text,
      }
      break
    case SEARCH_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case SEARCH_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    default:
      state = {...state}
      break
  }

  return state
}

export default Search
